<script>
export default {
	mixins: [
		require('js/common/vuex/manager/read.mixin.vue'),
	],
	methods: {
		initManager: function(mgr){
			// Manager に初期化イベントを発行
			mgr.onInitialize();

			// Manager インスタンス を Vuex に保存
			this.$store.commit("manager_set_instance",mgr);
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/vuex/manager/write.mixin.vue